// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".render-cls1___52b8cf5bc12650671c8{/*!*/}.render-cls2___4bb058922e74e57c8bc{word-break:break-word;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "render-cls1___52b8cf5bc12650671c8",
	"cls2": "render-cls2___4bb058922e74e57c8bc render-cls1___52b8cf5bc12650671c8"
};
export default ___CSS_LOADER_EXPORT___;
